import { useNavigate } from 'react-router-dom';
import CreatePaymentQrcode from '../withdrawals/components/PaymentQRcode';

export default function PixQrCodePage() {
  const navigate = useNavigate();
  return <CreatePaymentQrcode onClose={() => navigate('/access/saques')} asPage />;
}
